import { render } from "./WidgetHeader.vue?vue&type=template&id=5eb47902&scoped=true"
import script from "./WidgetHeader.vue?vue&type=script&lang=js"
export * from "./WidgetHeader.vue?vue&type=script&lang=js"

import "./WidgetHeader.vue?vue&type=style&index=0&id=5eb47902&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb47902"]])

export default __exports__